import { authedApiFetch } from '../../utils/Api';

export const action = async ({ params, request }) => {
	try {
		const formData = await request.formData();
		const jobId = params.jobId || formData.get('jobId');

		if (!jobId) {
			throw new Error('Job ID is required');
		}

		await authedApiFetch({
			endpoint: `/ascent/email/jobs/${jobId}`,
			method: 'PATCH',
			payload: {
				ascent_email_job: {
					status: 'canceled',
				},
			},
		});

		return { success: true, message: 'Successfully cancelled email job' };
	} catch (error) {
		console.error('Error cancelling job:', error);
		return { success: false, message: 'Failed to cancel email job' };
	}
};
